<template>
  <section class="service-container">
    <div class="service-container-content max-width">
      <div class="left">
        <div class="title-container">
          <div class="main-title">OUR</div>
          <div class="sub-title">SERVICE</div>
        </div>
        <h5 class="content-title">产品服务</h5>
        <p class="service-text">
          专注于大型政企、军工系统集成整体解决、信息化软件开发、机房建设、服务器等保、数据中心建设、信息化整体解决等模块
        </p>
      </div>
      <div class="right">
        <div class="item" v-for="item in sourceData" :key="item.business_id">
          <img :src="item.cover" />
          <div class="name">{{ item.business_name }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAllBusiness } from '@/api';
export default {
  data() {
    return {
      sourceData: [],
    };
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      const { data } = await getAllBusiness();
      this.sourceData = data.service;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('~@/assets/css/common.scss');
.service-container {
  padding: 90px 0;
  background-color: #f8f8f8;
  color: #fff;
  .service-container-content {
    margin: auto;
    display: flex;
    align-items: center;
    max-width: 1366px;
    .title-container {
      .sub-title {
        color: #333;
      }
    }
    .left {
      flex-grow: 186;
      position: relative;
      width: 40%;
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60px;
        height: 3px;
        background-color: #30659b;
      }
      .title-container {
        font-weight: bold;
      }
      .content-title {
        font-weight: bold;
        font-size: 18px;
        margin: 0;
        color: #333;
      }
      .service-text {
        font-size: 14px;
        line-height: 220%;
        margin-bottom: 40px;
        color: #333;
      }
    }
    .right {
      display: flex;
      flex-wrap: wrap;
      justify-content: end;
      .item {
        &:nth-child(3n + 2) {
          margin: 0 20px;
        }

        img {
          max-width: 240px;
          max-height: 240px;
        }
        .name {
          font-size: 14px;
          color: #333;
          text-align: center;
          padding: 20px 0 50px;
        }
        &:nth-child(n + 3) .name {
          padding-bottom: 0 !important;
        }
      }
    }
  }
}
</style>
